export const FILTRATION_SIDEBAR = "FILTRATION_SIDEBAR";
